import { LANGUAGE_FILTER_ALL } from '../config';

export const matchesLanguageFilter = (
  filter: string,
  language?: string,
): boolean =>
  filter === LANGUAGE_FILTER_ALL ||
  !language ||
  language.toLowerCase() === filter.toLowerCase();
